export default class DataUtils {
  static formatBoolean(value) {
    return value ? 'Yes' : 'No';
  }

  static formatString(value) {
    return value || 'N/A';
  }
}
